import React from 'react';

function ServicesAbout() {
    return (
        <>
            <section className="appie-services-2-area bg-light pt-90 pb-55" id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Features</h3>
                                <p>
                                    Our Frontdesk App comes with a variety of features, below is a
                                    list of the main features of our app.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-calendar-alt"></i>
                                </div>
                                <h4 className="title">Room Reservations</h4>
                                <p>
                                    Powerful tools that can help you manage your hotel rooms,
                                    reservations, and bookings with ease and efficiency.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-calendar"></i>
                                </div>
                                <h4 className="title">Real-time availability</h4>
                                <p>
                                    Our Frontdesk app allows you to manage your room availability in
                                    real-time, ensuring that your guests can book rooms when they're
                                    available.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-alt"></i>
                                </div>
                                <h4 className="title">Reporting and analytics</h4>
                                <p>
                                    Our app provides you with valuable insights into your sales data
                                    and inventory levels, allowing you to make data-driven decisions
                                    to grow your business.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-globe"></i>
                                </div>
                                <h4 className="title">Online booking</h4>
                                <p>
                                    OTO Frontdesk is designed to integrate seamlessly with your
                                    website booking engine, making it easier for your guests to book
                                    their stay online.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-retweet"></i>
                                </div>
                                <h4 className="title">POS Integraton</h4>
                                <p>
                                    Our Frontdesk app integration with our POS and users will be
                                    able to post bills guests' rooms
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-users"></i>
                                </div>
                                <h4 className="title">Guest management</h4>
                                <p>
                                    Easily manage guest information, including contact details,
                                    booking history, preferences, and special requests
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesAbout;
